var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9911 6.35449C12.6216 6.35449 10.3338 7.28392 8.62812 8.94871C6.92247 10.6033 5.92155 12.8605 5.83984 15.2402C5.83984 16.7518 6.28924 18.2328 7.10631 19.489C7.20845 19.6524 7.23909 19.8465 7.1676 20.0303L6.3403 22.0832C6.14625 22.5633 6.60585 23.0433 7.0961 22.8697L9.292 22.0832C9.46563 22.022 9.64947 22.0424 9.80267 22.1445C11.3551 23.1352 13.1629 23.6561 15.0115 23.6459C20.0672 23.6459 24.1628 19.8771 24.1628 15.2402C24.0811 12.8605 23.0802 10.6033 21.3643 8.94871C19.6485 7.28392 17.3709 6.35449 14.9911 6.35449Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4424 13.8193C12.0942 13.8195 12.623 14.3481 12.623 15C12.6229 15.6518 12.0941 16.1805 11.4424 16.1807C10.7905 16.1807 10.2618 15.6518 10.2617 15C10.2617 14.3481 10.7904 13.8193 11.4424 13.8193ZM15.1426 13.8193C15.7945 13.8193 16.3232 14.3481 16.3232 15C16.3232 15.6519 15.7945 16.1807 15.1426 16.1807C14.4907 16.1806 13.962 15.6519 13.9619 15C13.9619 14.3481 14.4907 13.8194 15.1426 13.8193ZM18.8438 13.8193C19.4955 13.8196 20.0234 14.3482 20.0234 15C20.0234 15.6518 19.4955 16.1804 18.8438 16.1807C18.1918 16.1807 17.6631 15.6519 17.6631 15C17.6631 14.3481 18.1918 13.8193 18.8438 13.8193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOn);
export default __webpack_public_path__ + "static/media/chat-on.2ac6fb397f3b7d64a47d88b644361017.svg";
export { ForwardRef as ReactComponent };